/*LIBRARY*/
import { useSelector, useDispatch } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { state_update } from "../../App/actions/sini_v2";

/*PICTURE*/

/*FUNCTION*/
import generate_uuid from "../../App/validation/generate_uuid";
import { get_dynamic_map_padding } from "../libre_layer/get_padding";

/*DATA*/
import dict from "../../Data/dict.json";
import { parseLatLon } from "../../App/validation/coordinates_validation";
import { Place } from "@material-ui/icons";

/*CONST*/

const SEARCH_LOCATION = () => {
  const dispatch = useDispatch();

  //global props
  const { auth, layer, properties } = useSelector((state) => state);
  const { location_result_list, search_input } = properties;

  const on_fly_to = ({ geometry, bbox }) => {
    dispatch(state_update());
    dispatch(
      set_value_properties({
        key: "modal_input",
        value: false,
      }),
    );
    dispatch(
      set_value_properties({
        key: "search_geometry",
        value: geometry,
      }),
    );
    dispatch(
      set_value_properties({
        key: "uuid_search",
        value: generate_uuid(),
      }),
    );

    const { map_object } = layer;
    const padding_fly = get_dynamic_map_padding();

    if (map_object) {
      if (geometry.type === "Point") {
        map_object.flyTo({
          center: geometry.coordinates,
          zoom: 16,
          padding: padding_fly,
        });
      } else {
        const [south, north, west, east] = bbox.map(Number);
        map_object.fitBounds(
          [
            [west, south],
            [east, north],
          ],
          {
            padding: padding_fly,
          },
        );
      }
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  const lat_lon = parseLatLon(search_input);
  let feature_by_lat_lon = null;
  if (lat_lon) {
    const { lat, lon } = lat_lon;
    feature_by_lat_lon = {
      coordinates: [lon, lat],
      type: "Point",
    };
  }

  //content
  return (
    <main>
      <p className="text_medium sub_color">
        {
          dict?.[
            "Search for locations by name/coordinates (latitude, longitude)"
          ]?.[language]
        }
      </p>
      {!lat_lon && location_result_list.length === 0 && !!search_input && (
        <p className="text_medium">{dict?.["No result"]?.[language]}</p>
      )}
      {location_result_list.length > 0 && (
        <section>
          <span className="button_pill_small background_black margin_right inline">
            {lat_lon
              ? location_result_list.length + 1
              : location_result_list.length}
          </span>
          <p className="text_medium inline">{dict?.["Result"]?.[language]}</p>
        </section>
      )}
      <section
        style={{
          overflowY: "auto",
          height: "500px",
          maxHeight: "calc((100vh - 300px))",
          marginTop: "20px",
        }}
      >
        {lat_lon && (
          <main
            className="button_white margin_bottom cursor_pointer"
            onClick={() =>
              on_fly_to({
                geometry: {
                  ...feature_by_lat_lon,
                  name: `${lat_lon.lat}, ${lat_lon.lon}`,
                },
              })
            }
          >
            <p className="text_bold margin_bottom">
              <Place style={{ height: "16px" }} />
              {`latitude: ${lat_lon.lat}, longitude: ${lat_lon.lon}`}
            </p>
            <br />
          </main>
        )}
        {location_result_list.map((feature, idx) => {
          return (
            <main
              key={idx}
              className="button_white margin_bottom cursor_pointer container"
              onClick={() =>
                on_fly_to({
                  geometry: {
                    ...feature?.geojson,
                    center: { long: feature.lon, lat: feature.lat },
                    name: feature?.display_name,
                  },
                  bbox: feature.boundingbox,
                })
              }
            >
              <p className="text_bold margin_bottom">{feature?.display_name}</p>
              <br />
            </main>
          );
        })}
      </section>
    </main>
  );
};

export default SEARCH_LOCATION;
